<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure><i class="icon icon-file"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Rapporteur <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Information</h3>
                                <p class="headline"></p>

                                <form-text label="Nom" v-model="resource.name" required="true"></form-text>

                                <form-datex label="Date début" v-model="resource.date_start"></form-datex>

                                <form-datex label="Date fin" v-model="resource.date_end" time="23.59.59"></form-datex>

                              </fieldset>


                              <fieldset>
                                <h3>Tabelle de prix</h3>
                                <p class="headline"></p>

                                <div class="table-excel" v-if="resource && resource.prices">
                                    <div>
                                        <div>
                                            <div style="width: 1px;padding:0px;"></div>
                                            <div style="">Capital garanti</div>
                                            <div style="width: 15%;">Tarif / accident</div>
                                            <div style="width: 15%;">Tarif / maladie</div>
                                            <div style="width: 15%;">Comm. DC</div>
                                            <div style="width: 15%;">Comm. A</div>
                                            <div style="width: 15%;">Comm. rappel DC</div>
                                            <div style="width: 1px;"></div>
                                        </div>
                                    </div>
                                    <draggable v-model="resource.prices" @start="drag=true" @end="drag=false" :options="{handle:'.drag'}">
                                        <div v-for="(value, index) in resource.prices">
                                            <div class="drag">
                                                <i class="icon icon-drag"></i>
                                            </div>
                                            <div><span class="currency">{{ currency }}</span><input type="text" v-model="value.amount_capital"/></div>
                                            <div><span class="currency">{{ currency }}</span><input type="text" v-model="value.amount_accident_repatriation"/></div>
                                            <div><span class="currency">{{ currency }}</span><input type="text" v-model="value.amount_sickness_repatriation"/></div>
                                            <div><span class="currency">{{ currency }}</span><input type="text" v-model="value.commission_a"/></div>
                                            <div><span class="currency">{{ currency }}</span><input type="text" v-model="value.commission_b"/></div>
                                            <div><span class="currency">{{ currency }}</span><input type="text" v-model="value.commission_c"/></div>
                                            <div class="actions">
                                                <button class="bt-remove" @click="removeRow(index)"><i class="icon icon-icon_close"></i></button>
                                            </div>
                                        </div>
                                    </draggable>
                                </div>

                                <div class="footer-buttons">
                                    <button @click="addRow()" class="btn"><span>Ajouter une ligne</span></button>
                                </div>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>
            </div>
        </div>
    </transition>
</template>
<script>

import TableService from './TableService.js';
import Edit from '../../../layouts/Edit.vue';

export default {
    extends: Edit,
    data () {
        return {
            resource: {
                prices: []
            },
            currency: null
        }
    },
    mounted: function(){
        this.currency = "CHF"
    },
    methods:{
        removeRow: function(index)
        {
            this.resource.prices.splice(index, 1);
        },
        addRow: function()
        {
            this.resource.prices.push({
                amount_capital: 0,
                amount_accident_repatriation: 0,
                amount_sickness_repatriation: 0,
                commission_a: 0,
                commission_b: 0,
                commission_c: 0
            });

            this.$forceUpdate();
        },
        addProtractor: function(){

        },
        addProtractorChild: function(){

        },
        resourceLoaded: function(){
            this.localesLoaded = true;
            this.resource.prices = this.resource.prices || [];
            this.initialize()
        },
        getResource: function(){
            return TableService
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/modules/serevita/table/Edit.vue